import React, { Component } from "react";


const PostImage = (props) => {
    return (
        <img src={props.img} alt="" />
    )
}

export default PostImage;
